export default "__VITE_PUBLIC_ASSET__a484334c__"